import { fetchPlace } from '../api/place'
import type { MessageSource } from './messageSource'

/** Adds the shop's branding from Firebase to a source that has none of its
 *  own: the legacy till's Firebase source, and the demo and e2e scripts. A
 *  device-request session brings its own branding and never goes through
 *  this. */
export function withFirebaseBranding(source: MessageSource, placeId: string): MessageSource {
  return {
    subscribe(listener) {
      let active = true
      // null when the read failed: unknown, not "this shop has no logo".
      void fetchPlace(placeId).then((place) => {
        if (active) listener.branding?.(place)
      })
      const unsubscribe = source.subscribe(listener)
      return () => {
        active = false
        unsubscribe()
      }
    },
  }
}
